import { Header, HStack, IconSelectFilled, Text, VStack } from '@direct-frontend/components';
import styles from './DashboardAlertsPlaceholder.module.css';

export const DashboardAlertsPlaceholder = () => (
    <VStack alignItems="center" gap="16" className={styles.container}>
        <HStack alignItems="center">
            <IconSelectFilled role="main" color="green" size="24" />
        </HStack>
        <VStack alignItems="center" gap="8">
            <Header textAlign="center" level="h3">
                Всё работает штатно
            </Header>
            <Text textAlign="center" role="supplementary">
                Пришлем сюда уведомление, если обнаружим ошибку
            </Text>
        </VStack>
    </VStack>
);
